import BackendService from "./BackendService";

async function getShift(id) {
  return BackendService.getData(`/shifts/${id}/`);
}
async function getShifts(params) {
  return BackendService.getData("/shifts/", {}, params);
}
async function getShiftTransactions(id) {
  return BackendService.getData(`/shifts/${id}/transactions/`);
}
async function getShiftDetails(id) {
  return BackendService.getData(`/shifts/${id}/`);
}
async function createShift(data) {
  return BackendService.post("/shifts/", data);
}

async function closeShift(id, data) {
  return BackendService.patch(`/shifts/${id}/close/`, data, {}, {}, undefined);
}

const ShiftService = {
  getShift,
  getShifts,
  getShiftTransactions,
  getShiftDetails,
  createShift,
  closeShift,
};

export default ShiftService;
